export default __webpack_public_path__ + "static/illustration-content-diagram-title.url-aba865b6351d4cecaa4048990db76da3.svg";